import axios from "../../api/axiosInstance";
import { STATUS, getProjectId, extractErrorInfo } from "./sharedfunction";

/**
 * Fetch NLP Configuration for the current project
 * GET /:projectId/nlp-configuration/fetch-nlp-configuration
 */
export async function fetchNlpConfiguration() {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${projectId}/nlp-configuration/fetch-nlp-configuration`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || null,
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching NLP configuration:", error);
    return extractErrorInfo(error);
  }
}

/**
 * Fetch NLP Configuration Details by ID
 * GET /:projectId/nlp-configuration/fetch-nlp-configuration-details/:id
 * @param {string} id - NLP Configuration ID (UUID)
 */
export async function fetchNlpConfigurationDetails({ id } = {}) {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    if (!id || id.trim().length === 0) {
      return {
        status: STATUS.ERROR,
        error: "NLP Configuration ID is required",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${projectId}/nlp-configuration/fetch-nlp-configuration-details/${id}`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching NLP configuration details:", error);
    return extractErrorInfo(error);
  }
}

/**
 * Update or create NLP Configuration
 * POST /:projectId/nlp-configuration/update-nlp-configuration
 * @param {object} configuration - Configuration object
 */
export async function updateNlpConfiguration({ configuration } = {}) {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    if (!configuration || typeof configuration !== 'object') {
      return {
        status: STATUS.ERROR,
        error: "Configuration is required",
      };
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${projectId}/nlp-configuration/update-nlp-configuration`,
      { configuration },
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error updating NLP configuration:", error);
    return extractErrorInfo(error);
  }
}


